import { render, staticRenderFns } from "./AccountingTransactionList.vue?vue&type=template&id=5964b508&"
import script from "./AccountingTransactionList.vue?vue&type=script&lang=js&"
export * from "./AccountingTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports